import ApiService from "../api.services";

const RoleService = {
  list: async function () {
    try {
      const response = await ApiService.get("/api/roles");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/roles/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  type: async function (type) {
    try {
      const response = await ApiService.get(`/api/roles/type/${type}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (
    code,
    name,
    user,
    customer,
    partner,
    super_admin_only,
    menu
  ) {
    const data = {
      role: {
        name,
        code,
        user,
        customer,
        partner,
        super_admin_only,
        menu,
      },
    };
    try {
      const response = await ApiService.post("/api/roles", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  update: async function (
    id,
    name,
    user,
    customer,
    partner,
    super_admin_only,
    menu
  ) {
    const data = {
      role: {
        name,
        name,
        user,
        customer,
        partner,
        super_admin_only,
        menu,
      },
    };
    try {
      const response = await ApiService.put(`/api/roles/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/roles/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default RoleService;

export { RoleService };
